import React from "react";
import { useRef } from "react";

export default function AutoLogout() {
  return (
    <div>
    </div>
  );
}
